export default __webpack_public_path__ + "static/media/slider1.d6196b60.jpg";